<app-product *ngIf="product" [product]="product" [disableRouting]="true" [isAdmin]="true"
             [interestedInProducts]="interestedInProducts" [similarProducts]="similarProducts"></app-product>
<app-alert-error [error]="error" [showAppLogo]="true"></app-alert-error>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>

